<div *ngIf="report">
      
  <div [style]="styles.header.page">
    <div [style]="styles.header.text"><b>THEIR STYLE COMBINATION PREFERENCE</b></div>

    <div [style]="styles.header.line"></div>
  </div>

  <div [style]="styles.container_padding">

    <h2 [style]="styles.general_h2"><b>Top Two Preferred Styles in Combination - {{ report.name }}</b></h2>
        
    <p [style]="styles.paragraph">Their top two preferred coaching styles from you are 
      <span [style]="styles.highlight">{{ report.primaryCoachingStyle }} </span> and 
      <span [style]="styles.highlight">{{ report.secondaryCoachingStyle }}</span>.</p>

    <p [style]="styles.paragraph" [innerHtml]="html"></p>

  </div>

</div>